import { createSlice } from "@reduxjs/toolkit";
import { DeviceState, onDeviceChange } from "../reducers/device-reducers";

export const deviceSlice = createSlice({
    name: "device",
    initialState: {
        matchesPhone: false,
        matchesTablet: false,
        matchesPc: false
    } as DeviceState,
    reducers: {
        changeDevice: onDeviceChange,
    }
})

export default deviceSlice.reducer;
export const { changeDevice } = deviceSlice.actions;
